import { render, staticRenderFns } from "./dutyNotice.vue?vue&type=template&id=d45eaddc&scoped=true&"
import script from "./dutyNotice.vue?vue&type=script&lang=js&"
export * from "./dutyNotice.vue?vue&type=script&lang=js&"
import style0 from "./dutyNotice.vue?vue&type=style&index=0&id=d45eaddc&lang=scss&scoped=true&"
import style1 from "./dutyNotice.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d45eaddc",
  null
  
)

export default component.exports